import { Calendar, FileText } from 'lucide-react';
import type { DocumentMetadata } from './types';

interface SourceFooterProps {
  metadata?: DocumentMetadata;
}

export function SourceFooter({ metadata }: SourceFooterProps) {
  if (!metadata) return null;

  const sourceName = metadata.source
    ?.replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
  const period = metadata.fiscal_year
    ? `FY${metadata.fiscal_year}`
    : metadata.fiscal_quarter
    ? `Q${metadata.fiscal_quarter}`
    : null;
  const docType = metadata.document_type?.toUpperCase();

  if (!sourceName && !period && !docType) return null;

  return (
    <div className="flex flex-wrap items-center gap-3 text-xs text-neutral-500 pt-4 mt-2 border-t border-neutral-100">
      {sourceName && (
        <span className="flex items-center gap-1">
          <FileText className="h-3 w-3 shrink-0" aria-hidden="true" />
          Source: {sourceName}
        </span>
      )}
      {period && (
        <span className="flex items-center gap-1">
          <Calendar className="h-3 w-3 shrink-0" aria-hidden="true" />
          {period}
        </span>
      )}
      {docType && (
        <span className="rounded bg-neutral-100 px-1.5 py-0.5 font-medium text-neutral-600">
          {docType}
        </span>
      )}
    </div>
  );
}
